import type { OverWritable } from '../../@types/settings';
import type { ColorSchema } from '../palette';
import type { ButtonGroupProps, Interpolation } from '@mui/material';
import type { Theme } from '@mui/material/styles';

const styleContained = (
  color: ColorSchema
): {
  props: Partial<ButtonGroupProps>;
  style: Interpolation<{ theme: Theme }>;
} => ({
  props: {
    variant: 'contained',
    color,
  },
  style: ({ theme }) => ({
    boxShadow: theme.customShadows[color],
  }),
});

export const buttonGroup: OverWritable = {
  MuiButtonGroup: {
    variants: [
      {
        props: {
          variant: 'contained',
          color: 'inherit',
        },
        style: ({ theme }) => ({ boxShadow: theme.customShadows.z8 }),
      },
      styleContained('primary'),
      styleContained('secondary'),
      styleContained('info'),
      styleContained('success'),
      styleContained('warning'),
      styleContained('error'),

      {
        props: { disabled: true },
        style: ({ theme }) => ({
          boxShadow: 'none',
          '& .MuiButtonGroup-grouped.Mui-disabled': {
            color: theme.palette.action.disabled,
            borderColor: `${theme.palette.action.disabledBackground} !important`,
            '&.MuiButton-contained': {
              backgroundColor: theme.palette.action.disabledBackground,
            },
          },
        }),
      },
    ],

    styleOverrides: {
      root: {
        '&:hover': {
          boxShadow: 'none',
        },
      },
    },
  },
};
